import api from '../api';
import { TOfferingsResponse, TQueryOfferingsParams } from './offerings.types';

export const offeringsEndpoint = 'punter/general/offerings';
export const queryOfferings = (params: TQueryOfferingsParams) =>
  api
    .get<TOfferingsResponse>(offeringsEndpoint, { params })
    .then((res) => res.data);
